import { SignalRSimulationService } from './predictor/services/signal-r-simulation.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { MessageService } from 'primeng/api';
import { Subject, BehaviorSubject, filter, take, takeUntil } from 'rxjs';
import { NotificationsActions } from './state/notifications/notifications.actions';
import { InactivityService } from './predictor/services/inactivity.service';
import{ExpiryNotificationService} from './global/components/expiry-notification/expiry-notification-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Debris Flow Predictor';
  toastData: { message: string; severity: string } | null = null;

  private ngUnsubscribe = new Subject();

  constructor(
    private messageService: MessageService,
    private actions$: Actions,
    private router: Router,
    private inactivityService: InactivityService,
    private signalRSimulationService: SignalRSimulationService,
    private expiryNotificationService: ExpiryNotificationService
  ) {
    this.expiryNotificationService.toast$
      .subscribe((toast) => {
        this.toastData = toast;
      });
  }

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  routerLoadingIndicator() {
    this.router.events
      .pipe(
        filter(
          (e) =>
            e instanceof NavigationEnd ||
            e instanceof NavigationCancel ||
            e instanceof NavigationError
        ),
        take(1)
      )
      .subscribe(() => {
        this.loading$.next(false);
      });
  }

  ngOnInit() {
    this.toast();
    this.routerLoadingIndicator();
    this.inactivityService.resetInactivityTimer();
  }

  toast() {
    this.actions$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        ofActionSuccessful(NotificationsActions.Toast)
      )
      .subscribe((result) => {
        this.messageService.add({
          severity: result.severity,
          detail: result.message,
          life: result.severity === 'error' ? 10000 : 3000,
        });
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
}
